import { combineEpics } from 'redux-observable';
import { registerUserWithOnetimePasswordRequestEpic } from './RegisterUserWithOnetimePasswordEpic/RegisterUserWithOnetimePasswordRequestEpic';
import { resendOnetimePasswordEpic } from './ResendOnetimePasswordEpic/ResendOnetimePasswordEpic';

export const userEpics = combineEpics(
  registerUserWithOnetimePasswordRequestEpic,
  resendOnetimePasswordEpic,
);
